import { createFileRoute } from '@tanstack/react-router';
import UserGroupDetails from '../../../administration/src/components/UserGroups/UserGroupDetails';

export const Route = createFileRoute('/_secured/administration/user-groups/$groupId')({
  component: UserGroupDetails,
});
